import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Button, Row, Col, message, Modal } from 'antd';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import Cookies from 'universal-cookie';
import { updateMxItemSkipAPI } from '../../../models/maintenance/actions';
import { updateMaintenance } from '../../../services/apiNew';
import { queryMaintenance } from '../../../services/api';
import globalStyles from '../../../utils/globalStyles.module.less';
import Loading from '../../TFLoading';
import bigIcon from './assets/maintenance-item.svg';
import smallIcon from './assets/icon-defect.svg';
import cancelIcon from './assets/cancel.svg';
import styles from './MXModal.module.less';
import ToleranceCounter from './ToleranceCounter';

const cookies = new Cookies();

class MXModalTolerance extends Component {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    item: PropTypes.object,
    visible: PropTypes.bool.isRequired,
    aircraft: PropTypes.object,
    updateMxItemSkipAPI: PropTypes.func.isRequired,
    intl: PropTypes.shape({ formatMessage: PropTypes.func }).isRequired,
    userSettings: PropTypes.object.isRequired,
  };

  static defaultProps = {
    item: {},
    aircraft: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      changedTolerances: {},
    };
  }

  handleSubmit = () => {
    const { changedTolerances } = this.state;
    const {
      item,
      aircraft,
      intl: { formatMessage },
    } = this.props;
    const id = item ? item.id : '';

    if (Object.keys(changedTolerances).length === 0) {
      message.error(formatMessage({ id: 'message.noToleranceAppliedByUser' }));
      return;
    }
    const payload = {
      id,
      fieldsValue: { ...changedTolerances },
      aircraft_id: aircraft.id,
      organisation_id: cookies.get('org'),
    };
    this.setState({ submitting: true }, async () => {
      try {
        const response = await updateMaintenance(payload);
        if (response && response.status >= 200 && response.status < 400) {
          const allMX = await queryMaintenance({ aircraft_id: aircraft.id });
          message.success(formatMessage({ id: 'message.mxItemUpdated' }, { name: response.data.name }));
          this.props.updateMxItemSkipAPI({ data: allMX, updatedID: id });
          this.props.hideModal();
          this.setState({ submitting: false, changedTolerances: {} });
        }
      } catch (error) {
        return null;
      }
      return null;
    });
  };

  getItemAreaName = (item) => {
    const { mx_type, name } = item;
    let itemArea = mx_type.substring(0, mx_type.lastIndexOf('_'));
    if (itemArea === 'apu') itemArea = 'APU';
    return (
      <>
        <span>{itemArea.replace(/_/g, ' ')},</span>
        {name}
      </>
    );
  };

  toleranceChange = (field, value) => {
    const { changedTolerances } = this.state;
    this.setState({
      changedTolerances: {
        ...changedTolerances,
        [field]: value,
      },
    });
  };

  render() {
    const {
      visible,
      aircraft,
      item,
      intl: { formatMessage },
      hideModal,
      userSettings,
    } = this.props;
    const { submitting } = this.state;
    const hasAPU = aircraft ? aircraft.apu_installed : false;
    const itemName = item ? this.getItemAreaName(item) : null;

    return (
      <Modal
        onCancel={hideModal}
        visible={visible}
        className={styles.modal}
        footer={null}
        width={900}
        closable
        closeIcon={<img src={cancelIcon} alt="cancelIcon" data-test="cancelIcon" className={styles.cancelIcon} />}
        destroyOnClose
        wrapClassName={styles.mxModalWrapper}
      >
        <Loading loading={submitting} contain />
        <Row gutter={16} className={styles.modalParentRow}>
          <Col md={8} className={styles.iconWrapper}>
            <img src={bigIcon} alt="sharingBigIcon" className={styles.bigIcon} data-test="bigIcon" />
          </Col>
          <Col lg={14} md={16}>
            <div className={styles.modalTitle} data-test="title">
              <img src={smallIcon} alt="sharingSmallIcon" className={styles.smallIcon} data-test="smallIcon" />
              {formatMessage({ id: 'title.applyTolerance' })} {itemName}
            </div>
            <div className={styles.modalContent}>
              {item && (
                <>
                  {item.flight_seconds_due !== null && (
                    <Row gutter={16} className={styles.modalRow}>
                      <Col md={24}>
                        <div className={styles.timesTitle} data-test="flightHoursTitle">
                          <span>{formatMessage({ id: 'period.fltHours' })}</span>
                        </div>
                      </Col>
                      <Col md={24}>
                        <ToleranceCounter
                          itemTolerance={item.flight_seconds_tolerance}
                          itemVisibleTolerance={item.flight_seconds_visible_tolerance}
                          nextDue={item.flight_seconds_due}
                          remaining={item.flight_seconds_remaining}
                          unitSingular={formatMessage({ id: 'units.hourShort' })}
                          unitPlural={formatMessage({ id: 'units.hoursShort' })}
                          type="seconds"
                          onChange={(value) => this.toleranceChange('flight_seconds_visible_tolerance', value)}
                          data-test="toleranceCounterFlightHours"
                        />
                      </Col>
                    </Row>
                  )}
                  {item.cycles_due !== null && (
                    <Row gutter={16} className={styles.modalRow}>
                      <Col md={24}>
                        <div className={styles.timesTitle} data-test="cyclesTitle">
                          <span>{formatMessage({ id: 'text.cycles' })}</span>
                        </div>
                      </Col>
                      <Col md={24}>
                        <ToleranceCounter
                          itemTolerance={item.cycles_tolerance}
                          itemVisibleTolerance={item.cycles_visible_tolerance}
                          nextDue={item.cycles_due}
                          remaining={item.cycles_remaining}
                          unitSingular={formatMessage({ id: 'units.cycle' })}
                          unitPlural={formatMessage({ id: 'units.cycles' })}
                          onChange={(value) => this.toleranceChange('cycles_visible_tolerance', value)}
                          data-test="toleranceCounterCycles"
                        />
                      </Col>
                    </Row>
                  )}
                  {item.date_due !== null && item.unit_of_time === 'months' && (
                    <Row gutter={16} className={styles.modalRow}>
                      <Col md={24}>
                        <div className={styles.timesTitle} data-test="monthsTitle">
                          <span>{formatMessage({ id: 'title.months' })}</span>
                        </div>
                      </Col>
                      <Col md={24}>
                        <ToleranceCounter
                          dateFormat={userSettings?.dateFormat}
                          itemTolerance={item.months_tolerance}
                          itemVisibleTolerance={item.months_visible_tolerance}
                          nextDue={item.date_due}
                          remaining={item.months_remaining}
                          unitSingular={formatMessage({ id: 'units.monthShort' })}
                          unitPlural={formatMessage({ id: 'units.monthsShort' })}
                          type="months"
                          onChange={(value) => this.toleranceChange('months_visible_tolerance', value)}
                          data-test="toleranceCounterMonths"
                        />
                      </Col>
                    </Row>
                  )}
                  {item.date_due !== null && item.unit_of_time === 'days' && (
                    <Row gutter={16} className={styles.modalRow}>
                      <Col md={24}>
                        <div className={styles.timesTitle} data-test="daysTitle">
                          <span>{formatMessage({ id: 'title.days' })}</span>
                        </div>
                      </Col>
                      <Col md={24}>
                        <ToleranceCounter
                          dateFormat={userSettings?.dateFormat}
                          itemTolerance={item.days_tolerance}
                          itemVisibleTolerance={item.days_visible_tolerance}
                          nextDue={item.date_due}
                          remaining={item.days_remaining}
                          unitSingular={formatMessage({ id: 'units.day' })}
                          unitPlural={formatMessage({ id: 'units.days' })}
                          type="days"
                          onChange={(value) => this.toleranceChange('days_visible_tolerance', value)}
                          data-test="toleranceCounterDays"
                        />
                      </Col>
                    </Row>
                  )}
                  {hasAPU && item.apu_seconds_due !== null && (
                    <Row gutter={16} className={styles.modalRow}>
                      <Col md={24}>
                        <div className={styles.timesTitle} data-test="apuHoursTitle">
                          <span>{formatMessage({ id: 'period.APUhours' })}</span>
                        </div>
                      </Col>
                      <Col md={24}>
                        <ToleranceCounter
                          itemTolerance={item.apu_seconds_tolerance}
                          itemVisibleTolerance={item.apu_seconds_visible_tolerance}
                          nextDue={item.apu_seconds_due}
                          remaining={item.apu_seconds_remaining}
                          unitSingular={formatMessage({ id: 'units.apuHour' })}
                          unitPlural={formatMessage({ id: 'units.apuHours' })}
                          type="seconds"
                          onChange={(value) => this.toleranceChange('apu_seconds_visible_tolerance', value)}
                          data-test="toleranceCounterAPUHours"
                        />
                      </Col>
                    </Row>
                  )}
                  <Row className={`${styles.rowSpaceTop} ${styles.rowSpaceTopBig}`}>
                    <Col md={24} className={styles.centerCol}>
                      <Button
                        type="primary"
                        onClick={() => this.handleSubmit()}
                        className={`${globalStyles.standardButton}
                          ${globalStyles.standardButtonWide}
                          ${globalStyles.standardButtonRounded}`}
                        data-test="submitButton"
                        loading={submitting}
                      >
                        {formatMessage({ id: 'form.button.applyTolerance' })}
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default compose(
  injectIntl,
  connect(
    ({ userSettings }) => ({ userSettings }),
    (dispatch) => ({
      updateMxItemSkipAPI: (payload) => {
        return dispatch(
          updateMxItemSkipAPI({
            payload,
          }),
        );
      },
    }),
  ),
  Form.create(),
)(MXModalTolerance);
